export default {"src":"/_next/static/media/amazon.6f479e86.svg","height":505,"width":1507,"blurWidth":0,"blurHeight":0};